export const predefineds = {
  blacklistedId: 115,
  whitlistedId: 116,
};

export const actionsIds = {
  endorsementTaskActionId: 701,
  changeProductPremiumActionId: "",
};

export const fnolStatuses = [
  { id: 1408, name: "Open", slug: "fnolStatus-open" },
  {
    id: 1409,
    name: "Assigned",
    slug: "fnolStatus-assigned",
  },
  {
    id: 1411,
    name: "Closed",
    slug: "fnolStatus-closed",
  },
  {
    id: "",
    name: "All",
    slug: "fnolStatus-all",
  },
];
export const dispatchesStatuses = [
  {
    id: "null",
    name: "New",
    slug: "dispatchStatus-new",
  },
  {
    id: 1726,
    name: "Initiated",
    slug: "dispatchStatus-initiated",
  },
  {
    id: 1159,
    name: "En Route",
    slug: "dispatchStatus-enRoute",
  },
  {
    id: 1160,
    name: "Arrived",
    slug: "dispatchStatus-arrived",
  },
  {
    id: 1161,
    name: "Completed",
    slug: "dispatchStatus-completed",
  },

  {
    id: 1162,
    name: "Cancelled",
    slug: "dispatchStatus-cancelled",
  },
  {
    id: "",
    name: "All",
    slug: "dispatchStatus-all",
  },
];
